import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { SettingsDebugSandboxContent } from "@/pages/settings/components/debug-sandbox/settings-debug-sandbox-content";
import { FC } from "react";

export const SettingsDebugSandboxPage: FC = () => {
  return (
    <SettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Debug Sandbox">
        <div>
          <SettingsDebugSandboxContent />
        </div>
      </SettingsSubsectionWrapper>
    </SettingsSectionWrapper>
  );
};
